import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  selectFormat,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";
import filterFactory from "react-bootstrap-table2-filter";

class LeeEngagementByPriceBucket extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { title } = this.props;

    data.forEach((d, i) => {
      d.id = i;
    });

    const columns = [
      {
        dataField: "name",
        text: "",
        style: { width: "140px", minWidth: "140px" },
        csvFormatter: (cell) => cell,
      },
      {
        dataField: "recent_week_user_engagements",
        text: "Recent Week User Engagements",
        style: { width: "110px", minWidth: "110px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "avg_weekly_user_engagements",
        text: "Avg Weekly User Engagements",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_user_engagements",
        text: "Delta User Engagements",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },

      {
        dataField: "recent_week_session_starts",
        text: "Recent Week Session Starts",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },

      {
        dataField: "avg_weekly_session_starts",
        text: "Weekly Session Starts",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_session_starts",
        text: "Delta Session Starts",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },
      {
        dataField: "recent_week_page_views",
        text: "Recent Week Pageviews",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },

      {
        dataField: "avg_weekly_page_views",
        text: "Avg Weekly Pageviews",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_page_views",
        text: "Delta Page Views",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },
      {
        dataField: "recent_week_video_starts",
        text: "Recent Week Video Starts",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },

      {
        dataField: "avg_weekly_video_starts",
        text: "Avg Weekly Video Starts",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_video_starts",
        text: "Delta Video Starts",
        style: { width: "80px", minWidth: "80px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },

      {
        dataField: "recent_week_engagements_per_session",
        text: "Recent Week Engagements Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },

      {
        dataField: "avg_weekly_engagements_per_session",
        text: "Avg Weekly User Engagements Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_engagements_per_session",
        text: "Delta User Engagements Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },
      {
        dataField: "recent_week_page_views_per_session",
        text: "Recent Week Page Views Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },

      {
        dataField: "avg_weekly_page_views_per_session",
        text: "Avg Weekly Page Views Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.0"),
      },
      {
        dataField: "delta_page_views_per_session",
        text: "Delta Weekly Page Views Per Session",
        style: { width: "140px", minWidth: "140px", textAlign: "left" },
        headerAlign: "left",
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <>
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={columns}
          striped={false}
          hover={false}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              filter={filterFactory()}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default LeeEngagementByPriceBucket;
